import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { UsuarioSessao } from '../../core/session.js';

interface RespostaLogin {
  usuario: UsuarioSessao;
  expiraEm: string;
}

interface RespostaMe {
  usuario: UsuarioSessao;
}

/** Adapter do módulo Auth no frontend — único ponto que conhece o formato das rotas `/api/v1/auth/*` (`apps/api/src/modules/auth/auth.routes.ts`). */
export class AuthApi {
  constructor(private readonly api: ApiClient) {}

  async login(email: string, senha: string): Promise<UsuarioSessao> {
    const resposta = await this.api.post<RespostaLogin>('/auth/login', { email, senha });
    return resposta.usuario;
  }

  async logout(): Promise<void> {
    await this.api.post<void>('/auth/logout');
  }

  /** `null` quando não há sessão válida (401) — não é tratado como erro, é o estado esperado de um visitante não autenticado. */
  async obterUsuarioAtual(): Promise<UsuarioSessao | null> {
    try {
      const resposta = await this.api.get<RespostaMe>('/auth/me');
      return resposta.usuario;
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 401) return null;
      throw erro;
    }
  }

  /** Conclui a troca de senha obrigatória (`UsuarioSessao.deveTrocarSenha`) — exige a senha atual (a temporária) para confirmar identidade na sessão já ativa. */
  async trocarSenhaObrigatoria(senhaAtual: string, novaSenha: string): Promise<void> {
    await this.api.post<void>('/auth/trocar-senha-obrigatoria', { senhaAtual, novaSenha });
  }
}
